import { UserId } from '@business/entities/account';
import { Endpoint } from '../endpoint';
import { BrandResponse, BrandId } from '@business/entities/brand';
import { CompanyId } from '@business/entities/companies';
import { OvertimeId, OvertimeResponse } from '@business/entities/overtime';
import { OvertimeFormData } from '@modules/dashboard/DashboardPage/ClockinToolbar/AddEditOvertimeModal/AddEditOvertimeModal';
import { OvertimeReportFormData } from '@modules/dashboard/DashboardPage/ClockinToolbar/OvertimeReportModal/OvertimeReportModal';
import { JobId } from '@business/entities/job';

export function fetchUserOvertimes(userId: UserId) {
  return Endpoint.get<OvertimeResponse[]>(`@gc/overtime/${userId}`);
}

export function createOvertime(data: OvertimeFormData) {
  return Endpoint.post<OvertimeResponse>(`@gc/overtime`, { data });
}

export function updateOvertime(id: OvertimeId, data: OvertimeFormData) {
  return Endpoint.patch<OvertimeResponse>(`@gc/overtime/${id}`, { data });
}

export function deleteOvertime(overtimeId: OvertimeId) {
  return Endpoint.delete<void>(`@gc/overtime/${overtimeId}`);
}

export function exportReport(params: OvertimeReportFormData) {
  return Endpoint.get<void>(`@gc/overtime/export`, { params });
}

export function downloadExport(jobId: JobId, filename: string) {
  return Endpoint.get<void>(`@gc/overtime/download-export/${jobId}`, { isFile: true, filename });
}
